import "./concursos.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { useNavigate } from "react-router-dom";
// import ConstantesObjetos from "../../utils/ConstantesObjetos";
import { getListaConcursos } from "../../components/services/ConcursosService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";


const Concurso = () => {
  const navigate = useNavigate();
  const [token] = useLocalStorage("token", "");
  const [loading, setLoading] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  // Estado con datos de las solicitudes traido desde la BBDD
  // const [datosSolicitud, setDatosSolicitudes] = useState(
  //   ConstantesObjetos.solicitudConcursoAnexo2
  // );

  const [concursos, setConcursos] = useState([]);

  useEffect(() => {
    getListaConcursos().then((data) => {
      setConcursos(data);
      setLoading(true);
      if (data.toString().startsWith("Error:")) {
        setShowFeedback(true);
        setLoading(false);
      }
    });
  }, [token]);

  function Concurso() {
    return (
      <>
        <div className="vh-100" >
          <Header></Header>
          <div
            className="container d-flex flex-column mt-5 pb-5"
            role="main" data-landmark-index="4"
          >
            {/* INFORMACION */}
            <div className="container p-5  rounded">
              <div className="container d-flex justify-content-start py-1">
                {/* <Titulo
                  tipo={"tituloModal "}
                  titulo={"Convocatorias Vigentes"}
                /> */}
                <h2 className="tituloAccesibilidad">Convocatorias Vigentes</h2>

              </div>
              <p>
                Estas son las convocatorias que actualmente están vigentes y que
                usted puede consultar:
              </p>
              {loading ? (
                concursos.length !== 0 ? (
                  concursos.map((concurso, i) => (
                    <button
                      className="btn2 my-3 p-2 rounded"
                      type="button"
                      onClick={() =>
                        navigate(`/concurso/${concurso.cbpxcabpro}`)
                      }
                      key={i}
                    >
                      <i className="fa-solid fa-graduation-cap"></i>
                      {concurso.cbpxcabpro + " - " + concurso.dconvocator}{" "}
                    </button>
                  ))
                ) : (
                  <p className="text-danger">No hay concursos disponibles.</p>
                )
              ) : showFeedback ? (
                <IfError
                  mensage="Error: No se ha podido conectar con el servidor.Intentelo más tarde."
                  ruta="/"
                ></IfError>
              ) : (
                <SpinnerCircle></SpinnerCircle>
              )}

              <p className="fw-bold">
                Teléfonos de consulta para la resolución de dudas en relación
                con el contenido de los certificados o el estado de la
                solicitud:
              </p>
              <p>
                Serv. de Gestión y Provisión de Personal / Registro G. de
                Personal: 924170133, 924170158, (Certificado Servicios Prestados
                924170135, 924170136) Escuela de Administración Pública:
                924008102, 924008100
              </p>

              <p className="pt-3">
                {" "}
                También puede presentar su consulta a través de la siguiente
                dirección de correo electrónico:{" "}
                <a className="enlace" href="https://outlook.office.com/mail/deeplink/compose?to=concursodetraslado@juntaex.es&subject=Consulta&body=Hola,%20tengo%20una%20pregunta.">concursodetraslado@juntaex.es</a>
              </p>
              <div className="gridBotones mb-2">
                <button
                  id="volver"
                  className="btnRed rounded btnCancelarDocumentacion"
                  type="button"
                  onClick={() => {

                    navigate("/home")

                  }}
                >
                  <i className="fa-solid fa-rotate-left"></i> Volver
                </button>
              </div>
            </div>
          </div>
          <Footer></Footer>
        </div>
      </>
    );
  }

  return <>{Concurso()}</>;
};

export default memo(Concurso);
